import { registerPlugin } from '@capacitor/core';
/**
 * @internal
 * @hidden
 */
export const ScanbotSDKPlugin = registerPlugin('ScanbotSDKCapacitor', {});
//# sourceMappingURL=Definitions.js.map